import script from "./template8.vue?vue&type=script&setup=true&lang=js"
export * from "./template8.vue?vue&type=script&setup=true&lang=js"

import "./template8.vue?vue&type=style&index=0&id=8de138aa&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8de138aa"]])

export default __exports__